import { APIErrorCode } from "./enums/api-error-code"

export enum GenericErrorCode{
    FailedFirebaseVerification = "failed_firebase_verification",
    InvalidPassword = "invalid_password",
    MissingUser = "missing_user",
    InvalidQuery = "invalid_query",
    QueryFailed = "query_failed",
    MissingBodyData = "missing_body_data",
    InvalidBodyData = "invalid_body_data",
    InvalidApiToken = "invalid_api_token",
    UnexpectedError = "unexpected_error",
    PreventingDuplicateData = "preventing_duplicate_data",
    DataNotFound = "data_not_found",
    SessionExpired = "session_expired",
    NoAccount = "no_account",
    MissingPermission = "missing_permission",
    InvalidAuthToken = "invalid_auth_token"
}

export interface FailedResponse{
    apiErrorCode: APIErrorCode,
    genericErrorCode:GenericErrorCode
    
}
